import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CertifiedBadge } from "@/components/CertifiedBadge";
import { FreshnessGauge } from "@/components/FreshnessGauge";
import BadgeDownload from "@/components/BadgeDownload";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";

export default function CertificationPublic() {
  const { code } = useParams();
  const [d, setD] = useState(null);

  useEffect(() => { api.get(`/certifications/public/${code}`).then((r)=>setD(r.data)).catch(()=>setD(false)); }, [code]);
  if (d === null) return <div className="p-10 text-slate-500">Loading…</div>;
  if (d === false) return <div className="p-10 text-slate-500">Certification not found.</div>;

  const { certification: c, property: p, host } = d;

  return (
    <div className="scent-wave min-h-[calc(100vh-4rem)]">
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-12">
        <div className="bg-white rounded-3xl border border-slate-200 overflow-hidden">
          <div className="bg-[#0A1128] text-white p-10 relative">
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-semibold">Public Certification</div>
            <h1 className="mt-2 font-serif text-4xl tracking-tight">Guest Smell™ Verified</h1>
            <div className="mt-2 text-slate-300 text-sm font-mono" data-testid="cert-code">Code: {code}</div>
            <div className="absolute -bottom-8 right-10">
              <div className="bg-white rounded-full shadow-xl border-2 border-[#D4AF37] w-20 h-20 flex items-center justify-center">
                <ShieldCheck className="w-10 h-10 text-emerald-600" />
              </div>
            </div>
          </div>
          <div className="p-10 grid md:grid-cols-3 gap-10 items-center">
            <div className="md:col-span-2">
              <CertifiedBadge tier={c.tier} compact />
              <h2 className="mt-3 font-serif text-3xl text-[#0A1128]" data-testid="cert-property">{p?.name}</h2>
              <div className="text-slate-500 text-sm mt-1">{p?.city}, {p?.country}</div>
              <div className="mt-4 grid grid-cols-2 gap-3 max-w-md">
                <Info label="Host" val={host?.name} />
                <Info label="Tier" val={c.tier?.toUpperCase()} />
                <Info label="Issued" val={new Date(c.decided_at).toLocaleDateString()} />
                <Info label="Status" val={c.status?.toUpperCase()} />
              </div>
              <div className="mt-6 flex gap-2">
                <Link to={`/property/${p?.id}`}>
                  <Button className="rounded-full bg-[#0A1128] hover:bg-[#1A2A3A] text-white" data-testid="cert-view-property">View Listing</Button>
                </Link>
              </div>
            </div>
            <div className="flex flex-col items-center gap-8">
              <FreshnessGauge score={p?.freshness_score || 0} />
              <BadgeDownload property={p} tier={c.tier} code={code} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Info({ label, val }) {
  return (
    <div className="border border-slate-200 rounded-xl p-3">
      <div className="text-[10px] tracking-[0.24em] uppercase text-slate-500">{label}</div>
      <div className="mt-1 font-medium text-[#0A1128]">{val || "—"}</div>
    </div>
  );
}
